import React from 'react';
import { dotStyle, flex } from '@fabric-ui/theme';
import { Box, useTheme } from '@mui/material';
import { stringToColor } from '../utils/utils';

interface AvAvatarProps {
  displayName?: string;
}

const AvAvatar: React.FC<AvAvatarProps> = ({ displayName = 'Unknown' }) => {
  const theme = useTheme();
  return (
    <Box
      component="span"
      sx={{
        ...flex.center,
        backgroundColor: stringToColor(displayName, theme.palette.avatarColors),
        ...dotStyle(undefined, '100%' as any),
      }}>
      <Box
        sx={{
          fontWeight: 600,
          fontSize: 12,
          color: theme.palette.white.main,
          textTransform: 'uppercase',
        }}>
        {displayName[0]}
      </Box>
    </Box>
  );
};
export default AvAvatar;
